import { tokenPrefix } from '@hivewatch/dark'

type ColorScheme = 'dark' | 'light'

export const darkAssociateModalStyles = (colorScheme: ColorScheme) => {
  const prefix = tokenPrefix(colorScheme)
  return {
    body: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '16px',
    },
    fieldValue: {
      color: `${prefix}text.primary`,
      textStyle: 'body',
    },
    sectionLabel: {
      color: `${prefix}text.secondary`,
      textStyle: 'label',
    },
    statusRow: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      gap: '8px',
    },
    tailgateBox: {
      alignItems: 'center',
      border: '1px solid',
      borderColor: `${prefix}border.default`,
      display: 'flex',
      justifyContent: 'space-between',
      px: '12px',
      py: '12px',
    },
    tailgateTitle: {
      color: `${prefix}text.primary`,
      textStyle: 'body-bold',
    },
    tailgateDescription: {
      color: `${prefix}text.secondary`,
      textStyle: 'caption',
    },
    tailgateControls: {
      alignItems: 'center',
      display: 'flex',
      gap: '12px',
    },
    footerActions: {
      display: 'flex',
      gap: '8px',
    },
    footerRow: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    warningList: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '8px',
    },
  }
}
